import React from "react";
import { Layout, Avatar, Dropdown, Typography } from "antd";
import { UserOutlined, LogoutOutlined, DownOutlined } from "@ant-design/icons";
import "../styles/Dashboard.css";
import { useAuth } from "../context/AuthContext";
import logo from "../assets/ai360-logo-white.svg";

const { Header } = Layout;
const { Text } = Typography;

const HeaderComponent = () => {
  const { user } = useAuth();

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  const menu = {
    items: [
      {
        key: "logout",
        icon: <LogoutOutlined />,
        label: "Logout",
        danger: true,
        onClick: handleLogout,
      },
    ],
  };

  return (
    <Header className="dashboard-header">
      <div className="dashboard-logo">
        <img src={logo} alt="AI360" />
        <span className="logo-text">DMS</span>
      </div>
      <Dropdown menu={menu} trigger={["click"]}>
        <div className="dashboard-user" style={{ cursor: "pointer", gap: 8 }}>
          <Avatar size="small" icon={<UserOutlined />} style={{ background: "#2f54eb" }} />
          <Text strong style={{ marginInline: 8 }}>
            {user?.name || "User"}
          </Text>
          <DownOutlined style={{ fontSize: 10, color: "#9aa5b8" }} />
        </div>
      </Dropdown>
    </Header>
  );
};

export default HeaderComponent;
